module.exports = __webpack_public_path__ + "static/media/no-template.2f924086.jpg";